<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="template-font-files-add-form-modal-label">
                {{ $root.text(
                    'Upload {template} fonts',
                    {
                        template: this.$root.text(
                            this.$root.contents.template_title,
                            null,
                            false,
                            'template_title'
                        )
                    },
                    true
                ) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

            <div v-if="updated" class="alert alert-success" role="alert">
                <div class="row">
                    <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                    <div class="col" v-html="updated"></div>
                </div>
            </div>

            <div v-if="updating">
                <loading></loading>
            </div>

            <div :style="'display: ' + ((!updating && !updated) ? 'block' : 'none')">
                <vue-dropzone
                    v-if="dropzone_options"
                    ref="templateFontFilesDropzone"
                    id="template-font-files-dropzone"
                    :options="dropzone_options"
                    v-on:vdropzone-sending="onSendingFile"
                    v-on:vdropzone-upload-progress="onProgressUpdate"
                    v-on:vdropzone-success="onFileUploaded"
                    v-on:vdropzone-error="onUploadError"
                    v-on:vdropzone-drag-over="onDragOver"
                    v-on:vdropzone-drag-leave="onDragLeave"
                    v-on:vdropzone-drop="onDragLeave"
                    v-on:vdropzone-file-added="onFileAdded"
                    :useCustomSlot=true
                >
                    <div v-for="file in uploaded_files" :key="file.id" class="dz-uploaded-file p-2 mb-1">
                        <div class="dz-thumbnail">
                            <span v-if="!file.preview_image">
                                <img
                                    :src="$root.imagePlaceholder(file.filename)"
                                    class="img-fluid"
                                    alt=""
                                >
                            </span>
                            <img
                                v-else
                                :src="file.preview_image"
                                class="img-fluid"
                                alt=""
                            >
                        </div>
                        <div class="dz-filename">{{ file.filename }}</div>
                        <div class="dz-size" v-html="$root.formatFileSize(file.file_size)"></div>
                        <div class="dz-remove">
                            <a
                                v-if="!updating"
                                href="#"
                                v-b-tooltip.hover
                                :title="$root.text('Delete', null, true)"
                                @click.prevent="removeUploadedFile(file.id)"
                            >
                                <i class="fal fa-trash-alt"></i>
                            </a>
                            <span v-if="updating"><i class="fal fa-trash-alt"></i></span>
                        </div>
                        <div
                            class="dz-upload-info"
                            :id="'upload-info' + file.id"
                            style="left: 160px"
                        >
                            <i class="fal fa-clock mr-1"></i> {{ $root.text('Pending upload', null, true) }}
                        </div>
                        <div
                            class="dz-progress"
                            :id="'upload-progress' + file.id"
                            style="width: calc(100% - 172px)"
                        >
                            <div class="dz-upload"></div>
                        </div>
                    </div>
                    <a
                        href="#"
                        class="dz-add-files"
                        id="template-font-files-add-files"
                        @click.prevent="doNothing()"
                        :style="dzAddFilesStyle()"
                    >
                        <i class="far fa-cloud-upload-alt font-size-20 mr-1"></i>
                        {{ $root.text('Click or drop font files here to upload.', null, true) }}
                        <br>
                        {{ $root.text('Supported types: TTF, OTF, WOFF or WOFF2', null, true) }}
                    </a>
                </vue-dropzone>
            </div>
        </div>
        <!--<div class="modal-footer" :style="modalFooterStyle()">
            <div v-if="uploading" class="progress-display" v-html="uploadProgress()"></div>

            <span class="button-holder" :style="addMoreFilesStyle()">
                <button
                    :key="'add-more-files'"
                    type="button"
                    class="btn btn-secondary"
                    id="template-font-files-add-more-files"
                    :disabled="updating"
                >
                    <i class="far fa-cloud-upload-alt mr-1"></i>
                    {{ $root.text('Add more files', null, true) }}
                </button>
            </span>

            <span v-if="!updating">
                <button
                    :key="'submit-button'"
                    type="submit"
                    class="btn btn-primary"
                    @click="onSubmit()"
                    :disabled="uploading || (uploaded_files.length == 0)"
                >
                    <i class="far fa-check mr-1"></i> {{ $root.text('Finish', null, true) }}
                </button>
            </span>
            <span v-else>
                <button :key="'submitting-button'" type="button" class="btn btn-primary">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">{{ $root.text('Finish', null, true) }}</span>
                </button>
            </span>
        </div>-->
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone';
    export default {
        components: {
            'vue-dropzone': vue2Dropzone
        },
        data () {
            return {
                errors: false,
                uploading: false,
                upload_progress_message: false,
                uploaded_files: [],
                upload_progress: {
                    progress: 0,
                    bytes_total: 0,
                    bytes_sent: 0
                },
                dropzone_options: null,
                updating: false,
                updated: false
            }
        },
        mounted () {
            var vm = this;
            this.dropzone_options = {
                url: this.$root.app.api_url + '/' + this.$root.app.client_id + '/upload-v2',
                acceptedFiles: '.ttf,.otf,.woff,.woff2',
                createImageThumbnails: true,
                maxThumbnailFilesize: 20,
                thumbnailWidth: 50,
                thumbnailHeight: 50,
                uploadMultiple: false,
                parallelUploads: 1,
                chunking: true,
                forceChunking: true,
                parallelChunkUploads: false,
                chunkSize: 10000000,
                retryChunks: true,
                retryChunksLimit: 5,
                maxFilesize: (10 * 1000 * 1000),
                autoProcessQueue: true,
                timeout: 0,
                clickable: '#template-font-files-add-files, #template-font-files-add-more-files',
                headers: {
                    'Authorization': 'Bearer ' + this.$root.token
                },
                accept: function (file, done) {
                    const ext = vm.$root.getFileExtension(file.name);
                    const allowedExtensions = ['ttf', 'otf', 'woff', 'woff2'];
                    if (allowedExtensions.indexOf(ext) < 0) {
                        done(
                            {
                                error: vm.$root.text('File type not accepted', null, true),
                                filename: file.name,
                                file_type: file.type
                            }
                        );

                        return null;
                    }
                    done();
                }
            };
        },
        methods: {
            resetForm: function () {
                this.errors = false;
                this.uploading = false;
                this.upload_progress_message = false;
                this.uploaded_files = [];
                this.upload_progress = {
                    progress: 0,
                    bytes_total: 0,
                    bytes_sent: 0
                };
                this.updating = false;
                this.updated = false;
            },
            doNothing: function () {
                return false;
            },
            dzAddFilesStyle: function () {
                if (this.uploaded_files.length == 0) {
                    return 'display: block';
                }

                return 'display: none';
            },
            onFileAdded: function (file) {
                if (this.updating) {
                    this.$refs.templateFontFilesDropzone.removeFile(file);

                    return null;
                }

                // Check file size.
                if (file.size > this.dropzone_options.maxFilesize) {
                    this.$refs.templateFontFilesDropzone.removeFile(file);
                    const appComponent = this.$root.findComponent(this.$root, 'main-app');
                    appComponent.message = {
                        type: 'error',
                        title: this.$root.text('Maximum upload size exceeded', null, true),
                        text: this.$root.text('The maximum size of the file you can upload is {size}.',
                            { size: this.$root.formatFileSize(this.dropzone_options.maxFilesize) }, true) + ' '
                            + this.$root.text('The size of {filename} is {size}.',
                            { filename: file.name, size: this.$root.formatFileSize(file.size) }, true)
                    };
                    $('#message-modal').modal('show');
                    $('.modal-backdrop').css({ 'z-index': '1060', 'opacity': '0.25' });

                    return null;
                }

                this.errors = false;
                this.uploading = true;
                let newFile = {
                    id: file.upload.uuid,
                    upload_id: this.$root.getUploadFileId(file),
                    filename: file.name,
                    file_type: file.type,
                    file_size: file.size,
                    upload: {
                        progress: 0,
                        bytes_sent: 0
                    },
                    preview_image: (file.dataURL || null),
                    update_status: null
                };
                this.uploaded_files.push(newFile);
                var vm = this;
                setTimeout(function () {
                    $('#upload-info' + file.upload.uuid).html(vm.$root.text('Preparing upload...', null, true));
                }, 500);
            },
            onDragOver: function (event) {
                $('#template-font-files-dropzone').addClass('dz-drag-highlight');
            },
            onDragLeave: function (event) {
                $('#template-font-files-dropzone').removeClass('dz-drag-highlight');
            },
            onSendingFile: function (file, xhr, formData) {
                formData.append('id', this.$root.getUploadFileId(file));
            },
            onProgressUpdate: function (file, progress, bytesSent) {
                if ((this.uploaded_files.length == 0) || (progress > 99.9)) {
                    return null;
                }
                let bytesTotal = 0;
                let bytesSentTotal = 0;
                this.uploaded_files.forEach((item) => {
                    bytesTotal += item.file_size;
                    if (item.id == file.upload.uuid) {
                        if (isNaN(bytesSent)) {
                            bytesSent = file.size * (progress / 100);
                        }
                        item.upload.progress = progress;
                        item.upload.bytes_sent = bytesSent;
                        bytesSentTotal += bytesSent;
                        $('#upload-info' + item.id).html(
                            this.$root.text('Uploading', null, true) + ' ' + this.$root.formatFileSize(bytesSent)
                                + ' ' + progress.toFixed(1) + '%'
                        );
                        $('#upload-progress' + item.id + ' > div').css('width', progress + '%');
                    } else if (item.upload.progress == 100) {
                        bytesSentTotal += item.file_size;
                    }
                });
                this.upload_progress.progress = ((bytesTotal * bytesSentTotal) > 0)
                    ? ((bytesSentTotal / bytesTotal) * 100) : 0;
                this.upload_progress.bytes_total = bytesTotal;
                this.upload_progress.bytes_sent = bytesSentTotal;
            },
            onFileUploaded: function (file, response) {
                if (this.uploaded_files.length == 0) {
                    return null;
                }
                // Find file.
                let itemIndex = -1;
                this.uploaded_files.forEach((item, index) => {
                    if (item.id == file.upload.uuid) {
                        itemIndex = index;
                    }
                });

                if (itemIndex > -1) {
                    this.uploaded_files[itemIndex].upload.progress = 100;
                    this.uploaded_files[itemIndex].upload.bytes_sent = file.size;
                    $('#upload-progress' + file.upload.uuid + ' > div').css('width', '100%');
                    if (!this.uploaded_files[itemIndex].preview_image) {
                        this.uploaded_files[itemIndex].preview_image = (file.dataURL || null);
                    }
                    $('#upload-info' + file.upload.uuid).html(
                        this.$root.text('Finalising upload...', null, true)
                    );
                    this.getUploadInfo(this.uploaded_files[itemIndex].upload_id);
                    this.$refs.templateFontFilesDropzone.removeFile(file);
                }
            },
            getUploadInfo: function (fileId) {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/upload-info/' + fileId;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    // Find file.
                    let itemIndex = -1;
                    vm.uploaded_files.forEach((item, index) => {
                        if (item.upload_id == response.data.file_id) {
                            itemIndex = index;
                        }
                    });
                    if (itemIndex < 0) {
                        return null;
                    }

                    vm.uploaded_files[itemIndex].temp_file = response.data.temp_file;
                    vm.onUploadComplete();
                    $('#upload-info' + vm.uploaded_files[itemIndex].id).html('');
                })
                .catch(function (error) {
                    // Do anything?
                });
            },
            onUploadComplete: function () {
                let allUploaded = true;
                this.uploaded_files.forEach((item) => {
                    if (!item.temp_file) {
                        allUploaded = false;
                    }
                });
                if (!allUploaded) {
                    return null;
                }
                this.uploading = false;
                this.upload_progress.progress = 0;
                this.onSubmit();
            },
            onUploadError: function (file, message, xhr) {
                if (file.status != 'canceled') {
                    if (message.error) {
                        this.errors = message.error + ' ' + message.filename + ' (' + message.file_type + ')'
                            + '<br><br>'
                            + this.$root.text('Please choose a TTF, OTF, WOFF or WOFF2 file.', null, true);
                    } else {
                        this.errors = this.$root.text('Something went wrong, please try again', null, true);
                    }
                }
                this.removeUploadedFile(file.upload.uuid, true);
                this.onUploadComplete();
                console.log(file, message);
            },
            removeUploadedFile: function(fileId, confirmed = false) {
                let fileIndex = -1;
                this.uploaded_files.forEach((item, index) => {
                    if (item.id == fileId) {
                        fileIndex = index;
                    }
                });
                if (fileIndex > -1) {
                    if (confirmed) {
                        const removeUploadFileId = (this.uploaded_files[fileIndex].upload.progress < 100) ? fileId
                            : null;

                        this.uploaded_files.splice(fileIndex, 1);

                        if (removeUploadFileId) {
                            this.$refs.templateFontFilesDropzone.getUploadingFiles().forEach((file) => {
                                if (file.upload.uuid == removeUploadFileId) {
                                    this.$refs.templateFontFilesDropzone.removeFile(file);
                                }
                            });
                            this.$refs.templateFontFilesDropzone.getQueuedFiles().forEach((file) => {
                                if (file.upload.uuid == removeUploadFileId) {
                                    this.$refs.templateFontFilesDropzone.removeFile(file);
                                }
                            });
                        }
                    
                        return null;
                    }

                    this.$parent.confirm_delete = {
                        title: this.$root.text('Delete file', null, true),
                        text: this.$root.text(
                            'Are you sure you want to delete: {filename}?',
                            { filename: this.uploaded_files[fileIndex].filename },
                            true
                        ),
                        component: this,
                        action: 'delete-file-' + fileId
                    };
                    $('#confirm-delete-modal').modal('show');
                    $('.modal-backdrop').css({ 'z-index': '1060', 'opacity': '0.25' });
                }
            },
            confirmDelete: function (action) {
                if (action.indexOf('delete-file-') > -1) {
                    const fileId = action.substr(12);
                    this.removeUploadedFile(fileId, true);
                }
            },
            onSubmit: function () {
                if (!this.updating) {
                    this.errors = false;
                    this.updating = true;
                }
                
                // Find next file.
                let nextFileIndex = -1;
                let numUpdated = 0;
                this.uploaded_files.forEach((item, index) => {
                    if (item.update_status === null) {
                        nextFileIndex = index;
                    } else if (item.update_status) {
                        numUpdated++;
                    }
                });

                if (nextFileIndex < 0) {
                    // All done.
                    this.updated = this.$root.text(
                        '{x} of {y} {template} fonts uploaded successfully.',
                        {
                            x: numUpdated,
                            y: this.uploaded_files.length,
                            template: this.$root.text(
                                this.$root.contents.template_title,
                                null,
                                false,
                                'template_title'
                            )
                        }
                    );
                    this.updating = false;

                    // Reload fonts.
                    this.$parent.getFonts();

                    // Update font files.
                    this.$root.updateTemplateFonts();

                    if (this.errors) {
                        return null;
                    }

                    setTimeout(function () {
                        $('#template-font-files-add-form-modal').modal('hide');
                    }, 2000);

                    return null;
                }

                const file = this.uploaded_files[nextFileIndex];
                const data = {
                    template_font_id: 0,
                    temp_file: file.temp_file,
                    filename: file.filename,
                    file_type: file.file_type,
                    file_size: file.file_size
                };
                var vm = this;

                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/template-font-file';

                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    file.update_status = true;
                })
                .catch(function (error) {
                    file.update_status = false;
                    let errorAdd = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response) {
                        if (error.response.status == 401) {
                            // Missing/lost API token - close modal and logout user.
                            $('#template-font-files-add-form-modal').modal('hide');
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            errorAdd = error.response.data.error;
                        }
                    }
                    if (!vm.errors) {
                        vm.errors = '';
                    } else {
                        vm.errors += '<br>';
                    }
                    vm.errors += errorAdd;
                })
                .finally(() =>
                    vm.onSubmit()
                );
            },
            modalFooterStyle: function () {
                if (!this.updated) {
                    return 'display: flex';
                }

                return 'display: none';
            },
            uploadProgress: function () {
                if (this.upload_progress_message) {
                    return this.upload_progress_message;
                }
                const percent = this.upload_progress.progress.toFixed(1);

                return 'Uploading ' + ((percent < 100) ? percent : '100') + '%';
            },
            addMoreFilesStyle: function () {
                if (!this.uploading && !this.updating && (this.uploaded_files.length > 0)) {
                    return 'display: block';
                }

                return 'display: none';
            }
        }
    }
</script>
<style scoped>
    #template-font-files-dropzone {
        min-height: 126px;
    }

    #template-font-files-add-files {
        padding-top: 34px;
    }

    .dz-uploaded-file {
        cursor: default;
    }

    #template-font-files-add-more-files {
        position: absolute;
        left: 15px;
        bottom: 16px;
    }

    .progress-display {
        position: absolute;
        left: 15px;
        bottom: 10px;
        width: calc(100% - 100px);
    }
</style>
